import React from "react";
import styled from "styled-components";

import { border, borderRadius } from "~/styles/mixins";

import { VerticalTabProps } from "./VerticalTab";

interface VerticalTabsProps {
  value: number;
  onChange: (event: React.SyntheticEvent, value: number) => void;
  children: React.ReactNode;
}

const VerticalTabs = React.forwardRef<HTMLDivElement, VerticalTabsProps>(
  function VerticalTabs({ value, onChange, children }, ref) {
    return (
      <StyledContainer ref={ref} role="tablist" aria-orientation="vertical">
        {React.Children.map(children, (child) => {
          if (!React.isValidElement<VerticalTabProps>(child)) {
            return child;
          }
          return React.cloneElement(child, {
            selected: child.props.index === value,
            onClick: (event: React.MouseEvent<HTMLButtonElement>) =>
              onChange(event, child.props.index),
          });
        })}
      </StyledContainer>
    );
  }
);

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${border.gray300()};
  ${borderRadius()};
  font-size: 14px;
  margin: 12px 0;
`;

export default VerticalTabs;
